// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__SYVXE","l3":"loading_l3__kRlJL"};